import exportProjectNameMapper from './ExportProjectNameMapper'
import { getAbsoluteExcerptUrl } from '../ExcerptUrlMapper'

const exportCodesMapper = (projectData, codesData, allExcerpts, transcripts) => {
  const host = window?.location?.host || "app.delvetool.com";
  
  // Map the flat codes array to the export format with excerpts
  const codes = (codesData || []).map(code => {
    // Filter excerpts for this code - check in codings array
    const codeExcerpts = (allExcerpts || []).filter(excerpt => 
      excerpt.codings?.some(coding => coding.code_id === code.id)
    );
    
    // Process synthesis text
    const synthesis = code.synthesis || '';
    const synthesisArray = synthesis.split('\n').filter(line => !!line && line.length > 0);
    
    // Build code URL - just use code.id
    const url = `https://${host}/projects/${projectData.id}/codes/${code.id}`;
    
    return {
      id: code.id,
      url: url,
      name: code.name,
      count: code.count || 0,
      position: code.position,
      level: code.level || 1, // Include level for the Exporter
      synthesisArray: synthesisArray,
      excerpts: codeExcerpts.map(excerpt => {
        const text = excerpt.text || "";
        const texts = text.split('\n').filter(line => !!line && line.length > 0);
        
        // Determine the transcript name based on excerpt type
        let transcriptName = 'Untitled';
        if (excerpt.codeable_type === 'SurveyAnswer') {
          transcriptName = excerpt.survey_title || 'Untitled Survey';
        } else if (excerpt.codeable_type === 'Transcript') {
          // Find the transcript from transcripts parameter
          const transcript = transcripts?.find(t => t.id === excerpt.transcript_id);
          transcriptName = transcript?.name || 'Untitled';
        }
        
        return {
          url: getAbsoluteExcerptUrl(excerpt),
          transcript_name: transcriptName,
          start: excerpt.start,
          end: excerpt.end,
          textArray: texts
        };
      }),
      children: [] // No children needed since codes are already flattened
    };
  });
  
  const {exportFileName} = exportProjectNameMapper(projectData, 'Codes.docx');
  
  return {
    codes: codes,
    fileName: exportFileName,
    projectName: projectData.name || 'Untitled Project'
  };
}

export default exportCodesMapper
